// extracted by mini-css-extract-plugin
module.exports = {"video-card__subtitle":"video-card_video-card__subtitle__NjEPT"};